import React, { useState, useContext, useEffect } from 'react';
import {
	TextField,
	Typography,
	Container,
	Stack,
	Button,
	Paper,
	InputAdornment,
	Divider,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Box,
	IconButton
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { DataContext } from '../../../../context/DataContext';
import { isAccess, simpleMessage } from '../../../../helpers/Helpers';
import { getToken } from '../../../../api/Account';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-regular-svg-icons';
import {
	addCreditNoteAsync,
	addQuoteAsync,
	getQuoteSugestAsync,
	getSaldoAnteriorAsync,
	getSaldoByTipoAbonoAsync,
	liquidateCreditAsync
} from '../../../../api/Credits';

import Swal from 'sweetalert2';

const AddAbono = ({ setShowModal, id, localReload, setLocalReload, isNominal }) => {
	const [montoAbono, setMontoAbono] = useState('');
	const [quoteSugest, setquoteSugest] = useState(0);
	const [totalAbonado, setTotalAbonado] = useState(0);
	const [nuevoSaldo, setNuevoSaldo] = useState(0);
	const [isLiquidate, setIsLiquidate] = useState(false);

	const [tipoAbono, setTipoAbono] = useState(1);

	const [metodoPago, setMetodoPago] = useState(1);
	const [entidadBancaria, setEntidadBancaria] = useState('');
	const [comprobanteFile, setComprobanteFile] = useState(null);
	const [comprobantePreview, setComprobantePreview] = useState(null);

	const token = getToken();
	const { setIsLoading, setIsUnautorized, access, setShowPrintBillModal, setDataAbono } =
		useContext(DataContext);

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			const result = await getQuoteSugestAsync(token, id);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setIsLoading(false);
			setquoteSugest(result.data.result);
			getSaldoAnterior(tipoAbono);
		})();
	}, []);

	//Devuelve un entero positivo
	const funtionSetMontoCuota = (value) => {
		if (/^\d*\.?\d*$/.test(value.toString())) {
			if (value > totalAbonado) {
				simpleMessage('No puede abonar mas de lo que debe', 'error');
				setMontoAbono(totalAbonado);
				setNuevoSaldo(0);
				return;
			}
			setMontoAbono(value);
			setNuevoSaldo(parseFloat(totalAbonado) - parseFloat(value === '' ? 0 : value));
			return;
		}
	};

	const onChangeComprobante = (e) => {
		const file = e.target.files[0];
		if (!file) return;

		if (comprobantePreview) {
			URL.revokeObjectURL(comprobantePreview);
		}
		setComprobanteFile(file);
		setComprobantePreview(URL.createObjectURL(file));
	};

	const removeComprobante = () => {
		if (comprobantePreview) {
			URL.revokeObjectURL(comprobantePreview);
		}
		setComprobanteFile(null);
		setComprobantePreview(null);
	};

	const addCuota = async () => {
		if (montoAbono.length === 0) {
			simpleMessage('Debe ingresar un monto a abonar', 'error');
			return;
		}

		if (nuevoSaldo < 0) {
			simpleMessage('No puede ingresar una cuota mayor al saldo del credito', 'error');
			return;
		}

		if (tipoAbono === 1 && metodoPago === 2) {
			if (entidadBancaria === '') {
				simpleMessage('Debe seleccionar la entidad bancaria', 'error');
				return;
			}
			if (!comprobanteFile) {
				simpleMessage('Debe adjuntar el comprobante de la transferencia', 'error');
				return;
			}
		}

		setIsLoading(true);

		const conceptos = {
			1: 'ABONO DEL DIA',
			3: 'NOTA DE CREDITO SEGURO',
			4: 'NOTA DE CREDITO INTERES CORRIENTE',
			5: 'NOTA DE CREDITO CAPITAL'
		};

		setIsLoading(true);

		// if (isLiquidate) {
		// 	const result = await liquidateCreditAsync(token, data);
		// 	if (!result.statusResponse) {
		// 		setIsLoading(false);
		// 		if (result.error === 'Unauthorized') {
		// 			setIsUnautorized(true);
		// 			return;
		// 		}
		// 		simpleMessage(result.error, 'error');
		// 		return;
		// 	}
		// 	simpleMessage('Nota de Crédito Aplicada...!', 'success');
		// } else {
		let result;
		if (tipoAbono === 1) {
			const formData = new FormData();
			formData.append('creditId', id);
			formData.append('totalRecibido', montoAbono);
			formData.append('concepto', conceptos[tipoAbono] ?? 'ABONO DEL DIA');
			formData.append('moneda', 1);
			formData.append('tipoAbono', tipoAbono);
			formData.append('metodoPago', metodoPago);
			if (metodoPago === 2) {
				formData.append('entidadBancaria', entidadBancaria);
				formData.append('foto', comprobanteFile);
			}
			result = await addQuoteAsync(token, formData);
		} else {
			const data = {
				creditId: id,
				totalRecibido: montoAbono,
				concepto: conceptos[tipoAbono] ?? 'ABONO DEL DIA',
				moneda: 1,
				tipoAbono: tipoAbono
			};
			result = await addCreditNoteAsync(token, data);
		}

		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		if (tipoAbono === 1) {
			printBill(result.data.result);
		} else {
			simpleMessage(`${conceptos[tipoAbono] ?? 'Nota de Crédito'} Aplicada...!`, 'success');
		}

		setIsLoading(false);

		setLocalReload(!localReload);
		setShowModal(false);
	};

	// const getSaldoAnterior = async () => {
	// 	const result = await getSaldoAnteriorAsync(token, id);
	// 	if (!result.statusResponse) {
	// 		setIsLoading(false);
	// 		if (result.error === 'Unauthorized') {
	// 			setIsUnautorized(true);
	// 			return;
	// 		}
	// 		simpleMessage(result.error, 'error');
	// 		return;
	// 	}
	// 	setIsLoading(false);
	// 	setTotalAbonado(result.data.result);
	// };

	const getSaldoAnterior = async (value) => {
		const result = await getSaldoByTipoAbonoAsync(token, { creditId: id, tipoAbono: value });
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setIsLoading(false);
		setTotalAbonado(result.data.result);
	};

	const onChangeTipoAbono = (tipo) => {
		setTipoAbono(tipo);
		getSaldoAnterior(tipo);
	};

	const printBill = (billData) => {
		Swal.fire({
			title: 'Cuota Aplicada...!',
			text: '¿Deseas imprimir el recibo?',
			icon: 'question',
			showCancelButton: true,

			confirmButtonColor: '#2979ff',
			cancelButtonColor: '#f50057',

			confirmButtonText: 'Imprimir!',
			cancelButtonText: 'Cancelar',
			customClass: {
				popup: 'border'
			}
		}).then((result) => {
			if (result.isConfirmed) {
				setDataAbono(billData);
				setShowPrintBillModal(true);
			}
		});
	};

	return (
		<div>
			<Container style={{ width: 550 }}>
				<Stack direction="column" spacing={1}>
					<Paper
						style={{
							padding: 20
						}}
					>
						<Stack direction="column" spacing={2} justifyContent={'center'}>
							<Stack
								direction="row"
								alignItems="center"
								justifyContent="space-around"
								divider={<Divider orientation="vertical" flexItem />}
							>
								<Stack spacing={1} direction="row" justifyContent={'center'}>
									<Typography
										fontWeight={'bold'}
										style={{
											color: '#2979ff'
										}}
									>
										CREDITO # :
									</Typography>
									<Typography
										style={{
											fontWeight: 'bold'
										}}
									>
										{id}
									</Typography>
								</Stack>

								<Stack spacing={1} direction="row" justifyContent={'center'}>
									<Typography
										fontWeight={'bold'}
										style={{
											color: '#00a152'
										}}
									>
										Ponerse Al Día :
									</Typography>
									<Typography
										style={{
											fontWeight: 'bold'
										}}
									>
										{`${new Intl.NumberFormat('es-NI', {
											style: 'currency',
											currency: 'NIO'
										}).format(quoteSugest)}`}
									</Typography>
								</Stack>
							</Stack>

							<Divider />

							<TextField
								required
								fullWidth
								onChange={(e) => funtionSetMontoCuota(e.target.value)}
								value={montoAbono}
								label={'Monto a abonar'}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">C$</InputAdornment>
									)
								}}
							/>

							<FormControl fullWidth style={{ textAlign: 'left' }}>
								<InputLabel id="demo-simple-select-standard-label">
									Tipo de abono
								</InputLabel>
								<Select
									labelId="demo-simple-select-standard-label"
									id="demo-simple-select-standard"
									onChange={(e) => onChangeTipoAbono(e.target.value)}
									value={tipoAbono}
									label="Tipo de Abono"
								>
									<MenuItem value={1}>ABONO DEL DIA</MenuItem>
									{/* <MenuItem value={2}>ABONO</MenuItem> */}
									{isAccess(access, 'CREDITNOTE') ? (
										<MenuItem value={3}>NOTA DE CREDITO SEGURO</MenuItem>
									) : null}
									{isAccess(access, 'CREDITNOTE') ? (
										<MenuItem value={4}>
											NOTA DE CREDITO INTERES CORRIENTE
										</MenuItem>
									) : null}
									{isAccess(access, 'CREDITNOTE') ? (
										<MenuItem value={5}>NOTA DE CREDITO CAPITAL</MenuItem>
									) : null}
									{/*	{isAccess(access, 'CREDIT LIQUIDATE') ? (
										<MenuItem value={4}>NOTA DE CREDITO MONTO TOTAL</MenuItem>
									) : (
										<></>
									)} */}
								</Select>
							</FormControl>

							{tipoAbono === 1 && (
								<FormControl fullWidth style={{ textAlign: 'left' }}>
									<InputLabel id="metodo-pago-label">Método de Pago</InputLabel>
									<Select
										labelId="metodo-pago-label"
										onChange={(e) => setMetodoPago(e.target.value)}
										value={metodoPago}
										label="Método de Pago"
									>
										<MenuItem value={1}>EFECTIVO</MenuItem>
										<MenuItem value={2}>TRANSFERENCIA</MenuItem>
									</Select>
								</FormControl>
							)}

							{tipoAbono === 1 && metodoPago === 2 && (
								<>
									<FormControl fullWidth style={{ textAlign: 'left' }}>
										<InputLabel id="entidad-bancaria-label">
											Entidad Bancaria
										</InputLabel>
										<Select
											labelId="entidad-bancaria-label"
											onChange={(e) => setEntidadBancaria(e.target.value)}
											value={entidadBancaria}
											label="Entidad Bancaria"
										>
											<MenuItem value={1}>LAFISE</MenuItem>
											<MenuItem value={2}>BILLETERA MÓVIL</MenuItem>
										</Select>
									</FormControl>

									<TextField
										required
										fullWidth
										type="file"
										label="Comprobante de Transferencia"
										inputProps={{
											accept: 'image/*'
										}}
										InputLabelProps={{ shrink: true }}
										onChange={onChangeComprobante}
									/>

									{comprobantePreview && (
										<Box
											sx={{
												position: 'relative',
												p: 1,
												height: 200,
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center'
											}}
											component={Paper}
										>
											<IconButton
												size="small"
												sx={{
													position: 'absolute',
													top: 8,
													right: 8,
													backgroundColor: 'rgba(255,255,255,0.8)',
													'&:hover': {
														backgroundColor: 'rgba(255,255,255,0.9)'
													}
												}}
												onClick={removeComprobante}
											>
												<Close />
											</IconButton>
											<img
												src={comprobantePreview}
												alt="Vista previa comprobante"
												style={{
													maxWidth: '100%',
													maxHeight: '100%',
													objectFit: 'contain'
												}}
											/>
										</Box>
									)}
								</>
							)}

							<Button
								variant="outlined"
								startIcon={
									<FontAwesomeIcon icon={faSave} style={{ marginRight: 20 }} />
								}
								fullWidth
								onClick={() => addCuota()}
								style={{
									color: '#00a152',
									borderColor: '#00a152'
								}}
								size="large"
							>
								Agregar Cuota
							</Button>
						</Stack>
					</Paper>

					<Paper
						style={{
							padding: 10
						}}
					>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="space-around"
							divider={<Divider orientation="vertical" flexItem />}
						>
							<Stack spacing={1} justifyContent={'center'}>
								<Typography
									fontWeight={'bold'}
									textAlign="center"
									style={{
										color: '#00a152'
									}}
								>
									{tipoAbono === 1
										? 'Saldo Anterior:'
										: tipoAbono === 3
										? 'Saldo Seguro:'
										: ''}
								</Typography>
								<Typography
									textAlign="center"
									style={{
										fontWeight: 'bold'
									}}
								>
									{`${new Intl.NumberFormat('es-NI', {
										style: 'currency',
										currency: 'NIO'
									}).format(totalAbonado)}`}
								</Typography>
							</Stack>

							<Stack spacing={1} justifyContent={'center'}>
								<Typography
									textAlign="center"
									fontWeight={'bold'}
									style={{
										color: '#f50057'
									}}
								>
									Nuevo Saldo:
								</Typography>
								<Typography
									textAlign="center"
									style={{
										fontWeight: 'bold'
									}}
								>
									{`${new Intl.NumberFormat('es-NI', {
										style: 'currency',
										currency: 'NIO'
									}).format(nuevoSaldo)}`}
								</Typography>
							</Stack>
						</Stack>
					</Paper>
				</Stack>
			</Container>
		</div>
	);
};

export default AddAbono;
